import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  selector: 'sp-toolbar, [spToolbar]',
  imports: [CommonModule],
  template: `
    <!-- Sp ToolBar -->
    <ng-content></ng-content>
  `,
  styleUrls: ['./toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarComponent {
  @HostBinding('class') class = 'sp-toolbar';
}
